import React from 'react'

import { Area } from 'recharts'

import transform from '../transform'
import colors from 'lib/colors'

import Empty from 'components/charts/empty'
import ChartContainer from 'components/charts/container'
import { formatDuration } from 'components/charts/utils'
import { APIGW_LATENCY } from 'containers/inventory/details/resource/metrics-tabs/services/apigateway'

const ApigatewayLatencyChart = ({ loading, data, height, span }) => {
  if (loading || !data) return null

  const metrics = transform({
    [APIGW_LATENCY]: data.APIGATEWAY_LATENCY,
    integration: data.APIGATEWAY_LATENCY_INTEGRATION
  })

  if (!metrics.length) return <Empty height={height} />

  const tooltipFormatter = (value, name, props) => {
    return [formatDuration(value), undefined]
  }

  return (
    <ChartContainer height={height}
      data={metrics}
      span={span}
      tabKey={APIGW_LATENCY}
      formatYTicks={value => formatDuration(value)}
      formatTab={value => formatDuration(value)}
      formatTooltip={tooltipFormatter}
    >
      <Area type='monotone' dataKey={APIGW_LATENCY} fill={colors('chart', 'red')} stroke={colors('chart', 'red')} name='Latency' dot={false} />
      <Area type='monotone' dataKey='integration' fill={colors('chart', 'redLight')} stroke={colors('chart', 'redLight')} name='Integration latency' fillOpacity={1} dot={false} />
    </ChartContainer>
  )
}

export default ApigatewayLatencyChart
